<template>
  <div id="HistoryList">
    <div class="history_list" v-for="(item,index) in list" :key="index">
      <div class="history_list_title">
        <div>{{item.CreateDate|setTime}}</div>
        <div>{{$t('colon.orderNumber')}}<em>{{item.OrderCode}}</em></div>
        <div class="avatar_box">
          <el-avatar class="avatar" src="../../../static/images/CardHobbyOfficial.png"></el-avatar>
          <em @click="allContact()">Card Hobby Official</em>
        </div>
        <div class="text_blue ContactSeller" @click="allContact()">
        </div>
      </div>
      <div class="history_list_box">
        <div class="history_list_detail">
          <div v-for="(res,i) in item.CommodityList" :key="i">
            <div class="like_box">
              <router-link class="like_box" :to="{path:'/storedetails/'+res.CommodityId}">
                <el-image class="like_img" :src="res.GFCommodityBody.Imgs[0]!='没有可上传的图片'?res.GFCommodityBody.Imgs[0]+'?imageView2/2/w/200':'../static/images/noimg.svg'" fit="contain"></el-image>
                <div class="img_p">
                  <p class="line_txt2">{{res.GFCommodityBody.Title}}
                  </p>
                  <div><span class="ConditionName">{{res.GFCommodityBody.Conditions[0].ConditionName}}</span></div>
                </div>
              </router-link>
            </div>
            <!-- NewPostageMoney -->
            <div class="history_box">
              <span>
                {{item.Currency}} {{formatAmount(res.Price)}}
              </span>
              <!-- <span class="text_gray line-through">
                {{item.Currency}} {{formatAmount(res.Price)}}
              </span> -->
            </div>
            <div class="history_box Quantity">x {{res.Quantity}}</div>
          </div>
        </div>
        <div class="history_box ship_cost">{{PostageMoney(item)}}</div>
        <div class="history_box">
          <span>{{item.Currency}} {{formatAmount(item.OrderAmount)}}</span>
          <!-- <br/>
          <span class="text_gray">{{$t('base.stateTax')}} {{item.Currency}} {{item.TaxAmount?item.TaxAmount:0}}</span> -->
        </div>
        <!-- state -->
        <div class="history_box tracking">
          <div class="text_red" v-if="type==1">{{$t('base.toBePaid')}}</div>
          <div class="text_gray" v-if="type==2">{{$t('base.toBeShipped')}}</div>
          <div class="text_gray" v-if="type==3">{{$t('base.shipped')}}</div>
          <div class="text_gray" v-if="type==4">{{$t('base.finished')}}</div>
        </div>
        <div class="history_box tracking">
          <!-- 待支付 -->
          <div class="history_btn" @click="BuyItNow(item)" v-if="item.OrderStatus==1">{{$t('base.payNow')}}</div>
          <!-- 待收货 -->
          <div class="history_btn" @click="confirm(item)" v-if="item.OrderStatus==3">{{$t('base.confirmItem')}}</div>
          <!-- 去看订单详情 -->
          <div class="history_txt">
            <router-link :to="{path:'/mycardhobby/orderdetail/'+item.Id}">{{$t('base.viewDetails')}}</router-link>
          </div>
          <!-- 待支付修改地址 -->
          <div v-if="item.OrderStatus==1" class="history_txt" @click="dialog(item,'address')">{{$t('base.changeAddress')}}</div>
          <div class="cursor history_txt" @click="dialog(item,'express')" v-if="item.OrderStatus>=3">{{$t('base.trackingDetails')}}</div>
        </div>
      </div>
    </div>
    <!-- 快递运费弹框 -->
    <get-express :title="dialogTitle" :dialogClass="dialogBox" :list="dialogList" :domVisible='dislogType.express' @closeDialog="closeDialog" v-if='dislogType.express' />
    <!-- 修改地址弹框 address-->
    <change-address :title="dialogTitle" :dialogClass="dialogBox" type='store' :list="dialogList" :domVisible='dislogType.address' :userInfo='userInfo' @closeDialog="closeDialog" v-if='dislogType.address' />
  </div>
</template>
<script>
import { getInfo, addressList, getTime, setUTC, numAdd, numMulti, countDown,formatAmount, isNumber, GoYunXin, priceExchange, doveCountDown } from "@/api/public";
import qs from 'qs'
import GetExpress from "@/components/dialog/express"; // 物流
import ChangeAddress from "@/components/dialog/changeaddress"; // 改地址

export default {
  name: 'historylist',
  components: {
    ChangeAddress,
    GetExpress
  },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      list: this.list,
      earthUser: false,
      nowData: new Date().getTime(),
      timer: "",
      dovetimer: '',
      userInfo: '',
      dialogBox: 'dialogBox',
      dialogVisible: false,
      dialogTitle: '',
      dialogList: '',
      viewList: '',
      dialogStyle: '',
      EquityVal: '',
      ID: 0,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  props: {
    list: {},
    type: 0,
    arrived: String
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeY(val) {
      return getTime(val, -8, 3, 'cn').split('|')[0]
    },
  },
  created() {
    this.userInfo = getInfo()
    //this.getAddressList();
    //this.cardTimer();
    //this.DoveTimer();
  },
  computed: {

  },
  methods: {
    formatAmount(obj){
      return formatAmount(obj)
    },
    //总价
    OrderTotal(obj) {
      return numAdd(isNumber(obj.OrderAmount), isNumber(obj.TaxAmount))
    },

    //邮费
    PostageMoney(obj) {
      if (obj.PostageType == '1') {
        return this.$t('base.payOnDelivery')
      }
      if (obj.PostageType == '2') {
        return this.$t('base.freeShipping')
      }
      if (obj.PostageType == '3') {

        return obj.Currency + " " + formatAmount(obj.Postage)
      }

    },
    // 云信
    allContact(val) {
      this.$root.$emit("contactUS", true);
    },

    // 订单确认收货
    SetReceive(obj, type) {
      let that = this
      let data = { MemberId: that.userInfo.MappingUserId, OrderId: obj.Id }
      this.$root.$emit("confirmLoading", true);
      this.$post(this.$interface.ConfirmReceipt, data).then(res => {
        if (res.Result != 0) {
          this.$emit('getDialog', false)
          this.closeDialog('confirmLoading', false)
        } else {
          this.$message({
            type: 'error',
            message: res.Msg
            //message: "You can't confirm item because it is disputing!"
          });
        }
      })

    },
    //弹框 Card Hobby Confirming
    doc() {
      let that = this
      this.$alert('<div style="text-align: center">' + that.$t('alert.cardHobbyProces') + '</div>', that.$t('base.conditionChecking'), {
        confirmButtonText: that.$t('base.ok'),
        lockScroll: false,
        dangerouslyUseHTMLString: true,
        callback: action => {}
      });
    },
    // 订单确认收货弹框
    confirm(obj) {
      let that = this
      //console.log(obj)
      // this.$confirm('<div class="confirmData">If you confirm the item before arrived, the order will be finished</div>', 'Will you confirm the item?', {
      this.$confirm('<div style="text-align: center">'+that.$t('alert.willYouConfirmItem')+'</div>', that.$t('base.confirmItem'), {
        confirmButtonText: that.$t('base.confirm'),
        cancelButtonText: that.$t('base.cancel'),
        customClass: "confirmBox Caution",
        lockScroll: false,
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.SetReceive(obj)
      }).catch(() => {});
    },
    // 弹框
    dialog(obj, val, res) {
      let that = this;
      if (val == 'confirm') {
        //订单收货确认
        that.dialogTitle = that.$t('base.conditionChecking');
        that.dialogStyle = 'view';
        that.dialogBox = "dialogBox"
        that.dislogType[val] = true;
        that.viewList = JSON.parse(JSON.stringify(obj))
        that.dialogList = JSON.parse(JSON.stringify(res));
      } else if (val == 'address') {
        //修改地址
        that.dialogTitle = that.$t('base.shipTo');
        that.dialogBox = "dialogBox"
        that.dislogType[val] = true;
        that.dialogList = JSON.parse(JSON.stringify(obj))
        //this.GetOrderDetail(obj)
      } else if (val == 'express') {
        //物流
        that.dialogTitle = that.$t('base.trackingDetails');
        that.dialogBox = "dialogBoxTracking";
        that.dislogType[val] = true;
        obj.IsExpressType = 1
        that.dialogList = JSON.parse(JSON.stringify(obj))
        //this.GetExpress(obj)
      }
    },
    // 付款
    BuyItNow(val) {
      let that = this;
      let data = val
      this.$router.push({
        path: '/pay/storecheckout/' + val.Id
      })
    },
    // 关闭弹框
    handleClose() {
      this.dialogVisible = false
      this.EquityVal = "";
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      if (val == 'comment') {
        this.$emit('getDialog', false)
      } else if (val == 'address') {
        this.$emit('getDialog', false)
      }
    },
    // 获取是否能分享优惠券
    GetShareCoupon(val) {
      let that = this;

      this.couponText = this.baseURL + '#/coupon?e=' + val.ID + '&t=' + that.userInfo.MappingUserId + '&m=' + encodeURIComponent(that.userInfo.HeadPortrait)
      let data = { memberId: that.userInfo.MappingUserId, orderId: val.ID }
      this.$get(this.$interface.GetShareCoupon, data).then(res => {
        if (res.result != 0) {
          this.dialog(val, 'coupon')
        } else {
          this.$message({
            type: 'error',
            //message: res.msg
            message: that.$t('alert.shareExpired')
          });
        }
      })
    },

  },
  //离开页面后清除定时器
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.dovetimer);
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";


.history_list_box .like_box .img_p {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.history_list_box .like_box .img_p span {
  color: #a0a0a0;
  font-size: 12px;
  margin-top: 8px;
}

.history_list_box .like_box .img_p p {
  line-height: 1.2;
  text-align: left;
  font-size: 14px;
}

.history_list_box .like_box .img_p p span {
  display: block;
  line-height: 1.2;
}

.history_list_box .like_box .img_p p span i:before {
  content: 'Tracking Number:';
  word-break: break-all;
}

.history_list_title>.ContactSeller {
  color: #333;
}

.history_list_title>.ContactSeller>div:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #5F6DAE;
}

.history_list_title>.GetCouponBtn {
  font-weight: bold;
  padding-right: 9px;
  position: absolute;
  right: 15px;
  background: url(../../../static/images/icon/icon_dollar.svg) right center no-repeat;
}

.Quantity {
  width: 75px;
}

.Coupon_f {
  cursor: pointer;
}

.ConditionName {
  border-radius: 2px;
  padding: 4px 12px;
  color: #a0a0a0;
  background: #f7f7f7;
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/list/orderlist.vue